import React, { useEffect } from "react";
import { Outlet, Navigate, useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";


const AuthFeature = () => {
  const user = useSelector((state: RootState) => state.authSlice.user);
  const accessToken = useSelector((state: RootState) => state.authSlice.accessToken);
  const navigate = useNavigate();

  useEffect(() => {
    // Only redirect if user and accessToken are fully available
    if (user && accessToken) {
      navigate("/dashboard");
    }
  }, [user, accessToken]);
  return (
    <div className="account-page">
      <div className="main-wrapper">
        <Outlet />
      </div>
    </div>
  );
};

export default AuthFeature;
